import React, { FC, MouseEventHandler, PropsWithChildren } from "react";
import "./Image-aside.css";
import ProgressiveImage from "react-progressive-graceful-image";

export interface Props extends PropsWithChildren {
  mainText: string;
  mainParagraph?: string;
  imageSrc: string;
  tinyImageSrc: string;
  buttonText: string;
  buttonEventHandler: MouseEventHandler;
  className?: string;
}

const ImageAside: FC<Props> = ({
  mainText,
  mainParagraph,
  imageSrc,
  tinyImageSrc,
  buttonText,
  children,
  className,
  buttonEventHandler,
}) => {
  return (
    <div className={`imageAside ${className}`}>
      <div className="grid-desktop">
        <div className="main">
          <div className="mainTextItems">
            <h2 className="mainText">{mainText}</h2>
            <p className="mainParagraph">{mainParagraph}</p>
          </div>

          {children && <div className="extraChildren">{children}</div>}

          <button className={buttonText === "" ? "hidden" :""} onClick={buttonEventHandler}>{buttonText}</button>

        </div>

        <div className="aside">
        <ProgressiveImage src={imageSrc} placeholder={tinyImageSrc}>
            {(src)=> <img src={src} alt="" className="image" />}
          </ProgressiveImage>
        </div>
      </div>

      <div className="grid-mobile ">
        <div className="main">
          <div className="mainTextItems">
            <h2 className="mainText">{mainText}</h2>
            <p className="mainParagraph">{mainParagraph}</p>
          </div>
        </div>

        <div className="aside">
          {children && <div className="extraChildren">{children}</div>}
          <ProgressiveImage src={imageSrc} placeholder={tinyImageSrc}>
            {(src)=> <img src={src} alt="" className="image" />}
          </ProgressiveImage>
        </div>

        <button className={buttonText === "" ? "hidden" :""} onClick={buttonEventHandler}>{buttonText}</button>
      </div>
    </div>
  );
};

export default ImageAside;
